'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef, useMemo } from 'react';
import { Icon, Stack, } from '../../index.js';
import styles from './icon-chip.module.css';
const sizes = {
    small: {
        icon: 12,
    },
    regular: {
        icon: 18,
    },
    big: {
        icon: 24,
    },
};
export const IconChip = forwardRef(({ style, className, dimension = 'regular', color = 'primary', icon, ...otherProps }, forwardedRef) => {
    const dynamicStyle = useMemo(() => ({
        '--background': `var(--highlight-${color}-background)`,
        '--foreground': `var(--highlight-${color}-foreground)`,
    }), [color]);
    return (_jsx(Stack, { as: "span", direction: "row", inline: true, ref: forwardedRef, fill: false, "data-icon-chip-dimension": dimension, className: clsx(styles.IconChip, className), vAlign: "center", hAlign: "center", style: { ...dynamicStyle, ...style }, ...otherProps, children: _jsx(Icon, { source: icon, className: styles.Icon, dimension: sizes[dimension].icon }) }));
});
